import React from "react";
import { AppButton, Callout } from "../../ui";

/**
 * StudentAttention — what about this student needs a person, and the one thing
 * to do about each.
 *
 * Renders NOTHING on a healthy record. A band that is always on screen stops
 * being read, and then it cannot do its job on the day it matters.
 *
 * Props:
 *   items   — studentRecord.buildAttention(), most urgent first
 *   actions — { [item.action]: { label, onClick, busy?, busyLabel? } }; an item
 *             whose action the page did not supply (no permission, feature off)
 *             still shows, without a button
 */
const StudentAttention = ({ items = [], actions = {} }) => {
  if (!items.length) return null;

  return (
    <section aria-label="Needs attention" className="tw-grid tw-gap-3 min-[992px]:tw-grid-cols-2">
      {items.map((item) => {
        const act = actions[item.action];
        return (
          <Callout
            key={item.key}
            tone={item.tone}
            action={act && (
              <AppButton size="xs" variant="outline" onClick={act.onClick} disabled={act.busy}>
                {act.busy ? act.busyLabel || act.label : act.label}
              </AppButton>
            )}
          >
            <span className="tw-block tw-text-[0.8125rem] tw-font-semibold tw-text-content">{item.title}</span>
            <span className="tw-block tw-text-xs tw-text-content-muted">{item.detail}</span>
          </Callout>
        );
      })}
    </section>
  );
};

export default StudentAttention;
